import React from 'react';

export const handlePinChange = (
  index: number,
  value: string,
  code: string[],
  setCode: React.Dispatch<React.SetStateAction<string[]>>,
  inputRefs: React.RefObject<(HTMLInputElement | null)[]>
) => {
  if (/^[0-9]$/.test(value) || value === '') {
    const newCode = [...code];
    newCode[index] = value;
    setCode(newCode);
    if (value === '' && index > 0 ) {
      inputRefs.current?.[index - 1]?.focus();
    }
    if (value !== '' && index < code.length && inputRefs.current) {
      inputRefs.current[index + 1]?.focus();
    }
  }
};
